import React from "react";
import * as styles from "./styles.module.scss";
import SiteGutter from "../../components/SiteGutter";
import SiteGrid from "../../components/SiteGrid";
import { Link } from "gatsby";
import cx from "classname";
import fastCompany from "./assets/FastCompany.svg";
import forbes from "./assets/Forbes.svg";
import rollingStone from "./assets/RollingStone.svg";
import businessInsider from "./assets/BusinessInsider.svg";
import wsj from "./assets/WSJ.svg";

export default function PressBanner({ data }) {
  return (
    <div className={styles.pressBanner}>
      <SiteGutter>
        <SiteGrid>
          <div className={styles.pressBannerWrapper}>
            <div className={styles.label}>{data.headline}</div>
            <img src={fastCompany} alt="Fast Company" width="174" height="26" />
            <img src={forbes} alt="Forbes" width="96" height="26" />
            <img
              src={rollingStone}
              alt="Rolling Stone"
              width="169"
              height="40"
            />
            <img src={wsj} alt="Wall Street Journal" width="61" height="36" />
            <img
              src={businessInsider}
              alt="Business Insider"
              width="106"
              height="34"
            />
            <Link
              to={data.cta.url}
              className={cx(styles.learnMore, "linkUnderline")}
            >
              {data.cta.label}
              <span className="srOnly">about our Press</span>
            </Link>
          </div>
        </SiteGrid>
      </SiteGutter>
    </div>
  );
}
